import { AutoCompleteLabel } from 'types';

export enum WebviewButtonLinkStepFormFieldsNames {
  Name = 'name',
  Input = 'input',
  NodeId = 'nodeId',
  Link = 'link',
  OptionFullWidth = 'optionFullWidth',
  Labels = 'labels',
}

export enum WebviewButtonLinkStepFormFieldsLinkNames {
  Url = 'url',
  Text = 'text',
  IncludeProjectParams = 'includeProjectParams',
  WaitingForComplete = 'waitingForComplete',
}

export interface WebviewButtonLinkStepFormFieldsLink {
  [WebviewButtonLinkStepFormFieldsLinkNames.Url]: string;
  [WebviewButtonLinkStepFormFieldsLinkNames.Text]: string;
  [WebviewButtonLinkStepFormFieldsLinkNames.IncludeProjectParams]?: boolean;
  [WebviewButtonLinkStepFormFieldsLinkNames.WaitingForComplete]?: boolean;
}

export interface WebviewButtonLinkStepFormFields {
  [WebviewButtonLinkStepFormFieldsNames.NodeId]: string;
  [WebviewButtonLinkStepFormFieldsNames.Name]: string;
  [WebviewButtonLinkStepFormFieldsNames.Input]: string;
  [WebviewButtonLinkStepFormFieldsNames.Link]: WebviewButtonLinkStepFormFieldsLink;
  [WebviewButtonLinkStepFormFieldsNames.OptionFullWidth]?: boolean;
  [WebviewButtonLinkStepFormFieldsNames.Labels]?: AutoCompleteLabel[];
}
